module.exports = global["$"] = require("-!/Users/sytec/dev/plenty/32028/23/TatyouTheme/node_modules/expose-loader/index.js?jQuery!./jquery.js");